import { render, staticRenderFns } from "./RamContent.vue?vue&type=template&id=dcda49ee&scoped=true"
import script from "./RamContent.vue?vue&type=script&lang=js"
export * from "./RamContent.vue?vue&type=script&lang=js"
import style0 from "./RamContent.vue?vue&type=style&index=0&id=dcda49ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcda49ee",
  null
  
)

export default component.exports